"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames4 = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["tagName", "text"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var SingleLink = function SingleLink(_ref) {
  var _ref$tagName = _ref.tagName,
    tagName = _ref$tagName === void 0 ? 'a' : _ref$tagName,
    text = _ref.text,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var TagName = tagName;
  return /*#__PURE__*/_react["default"].createElement(TagName, otherProps, text);
};

/**
 * Maps through each link and renders them in a list.
 * When `inlineAboveBreakpoint` is `null`, the list *only*
 * renders as a column, at all breakpoints. When `inlineAboveBreakpoint`
 * is set to one of the breakpoints (ie 'lg'), then at that breakpoint
 * and above, the list is moved inline, with default pipes `|` as separators.
 */
var LinkList = function LinkList(_ref2) {
  var className = _ref2.className,
    links = _ref2.links,
    linkClassName = _ref2.linkClassName,
    inlineAboveBreakpoint = _ref2.inlineAboveBreakpoint,
    inlineSeparator = _ref2.inlineSeparator,
    paddingBetweenInlineLinks = _ref2.paddingBetweenInlineLinks;
  var ulClassNames = (0, _classnames4["default"])('inline-block', _defineProperty(_defineProperty({}, className, className), "".concat(inlineAboveBreakpoint, "-flex"), inlineAboveBreakpoint));
  var separatorClassNames = (0, _classnames4["default"])('color-textBlackSoft px2 hidden', _defineProperty({}, "".concat(inlineAboveBreakpoint, "-inline"), inlineAboveBreakpoint));
  var listClassNames = (0, _classnames4["default"])(_defineProperty(_defineProperty({
    'items-center': inlineAboveBreakpoint
  }, "".concat(inlineAboveBreakpoint, "-flex"), inlineAboveBreakpoint), "".concat(inlineAboveBreakpoint, "-text-center"), inlineAboveBreakpoint));
  return /*#__PURE__*/_react["default"].createElement("ul", {
    className: ulClassNames
  }, links.map(function (linkItem, i) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      className: listClassNames,
      key: i
    }, inlineAboveBreakpoint && i !== 0 && /*#__PURE__*/_react["default"].createElement("span", {
      "aria-hidden": true,
      className: separatorClassNames
    }, inlineSeparator || '|'), /*#__PURE__*/_react["default"].createElement(SingleLink, _extends({
      className: "block ".concat(linkClassName, " ").concat(inlineAboveBreakpoint && i !== 0 ? "".concat(inlineAboveBreakpoint, "-px").concat(paddingBetweenInlineLinks) : "".concat(inlineAboveBreakpoint, "-pr").concat(paddingBetweenInlineLinks))
    }, linkItem)));
  }));
};
LinkList.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Applied to the `<ul />` parent element */
  className: _propTypes["default"].string,
  /** Applied to each link in the list */
  linkClassName: _propTypes["default"].string,
  /** Array of links to list */
  links: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    /** The text of the link */
    text: _propTypes["default"].any.isRequired,
    /** The href of the link */
    href: _propTypes["default"].string,
    /**
     * Tag for the link, defaults to a standard anchor
     */
    tagName: _propTypes["default"].any,
    /**
     * When using React Router, the links will often receive a 'to' prop
     */
    to: _propTypes["default"].string
  })),
  /**
   * If null, links will render in `block` only,
   * at all breakpoints. When set to a breakpoint,
   * the list renders inline above that breakpoint
   */
  inlineAboveBreakpoint: _propTypes["default"].oneOf([null, 'sm', 'md', 'lg', 'xl', 'xxl']),
  /**
   * Replaces default `|` as separator for inline links.
   * `inlineAboveBreakpoint` must have a truthy value
   */
  inlineSeparator: _propTypes["default"].any,
  /** Gives the links some additional tap space between each link when inline. It applies padding-x for all links except first, which only applies padding-right. Number corresponds to <a href="/guidelines/spacing/">Spacing Guidelines</a> */
  paddingBetweenInlineLinks: _propTypes["default"].number
} : {};
LinkList.defaultProps = {
  className: '',
  inlineAboveBreakpoint: null,
  inlineSeparator: '|',
  paddingBetweenInlineLinks: 0
};
LinkList.displayName = 'LinkList';
var _default = exports["default"] = LinkList;